var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"as":_vm.size ? 'h' + _vm.size : 'h1',"color":_vm.color,"bold":_vm.bold}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }